import styles from './LinkCard.module.scss'

const LinkCard: React.FC = () => {
  return (
    <section className={styles.link_cards}>
      <div className={styles.card}>
        <div className={styles.text_wrapper}>
          <p className={styles.title}>
            UX/UIデザイン<span>サービス</span>
          </p>
          <p className={styles.notice}>
            私たちは徹底したデザイン思考でアプリやウェブサイトを利用したビジネスを成功へとつなげます。
          </p>
          <a href="/services/uiuxdesign-lp2" target="_blank" rel="noopener" className={styles.button}>
            詳細はこちら
            <img src="/images/icons/link_box.svg" className={styles.box_img} alt="矢印" />
          </a>
        </div>
        <div className={styles.img_wrapper}>
          <div className={styles.img_uiux}></div>
        </div>
      </div>
      <div className={styles.card}>
        <div className={styles.text_wrapper}>
          <p className={styles.title}>
            フロントエンド<span>開発</span>
            <span>サービス</span>
          </p>
          <p className={styles.notice}>
            React JSやType Script、Next.jsなど、フロントエンド開発に特化したサービスです。
          </p>
          <a href="/services/frontend-dev" target="_blank" rel="noopener" className={styles.button}>
            詳細はこちら
            <img src="/images/icons/link_box.svg" className={styles.box_img} alt="矢印" />
          </a>
        </div>
        <div className={styles.img_wrapper}>
          <div className={styles.img_front}></div>
        </div>
      </div>
    </section>
  )
}

export default LinkCard
